<div class="video-container" [ngStyle]="getBoundings()">
  <div
    *ngFor="let obj of objects"
    class="video-object"
    [ngStyle]="{
      position: 'absolute',
      top: obj.y,
      left: obj.x,
      height: obj.height,
      width: obj.width,
      border: '1px solid blue'
    }"
  ></div>
</div>
